import queryString from 'query-string';

import { SEARCH_RADIUSES, getDefaultSearchRadius } from 'utils/constants';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch } from '..';

const queryParams =
  typeof window === 'object' ? queryString.parse(window.location.search) : {};

// Types

export type SetSearchRadiusAction = {
  type: 'SEARCH_RADIUS_SET';
  radius: string;
  didUserChange: boolean;
};
export type Action = SetSearchRadiusAction;

// Reducer

const parseRadius = ({
  radius,
  sort,
}: {
  radius?: string | null | undefined;
  sort?: string;
}) => {
  if (
    radius &&
    SEARCH_RADIUSES[USER_LOCALE].find((option) => option.id === radius)
  ) {
    return radius;
  }

  return getDefaultSearchRadius(sort);
};

export type State = {
  value: string;
  userHasChanged: boolean; // has the user ever changed the radius manually?
};
export default function searchRadiusReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    value: parseRadius(queryParams),
    userHasChanged: false,
  },
  action: Action
) {
  switch (action.type) {
    case 'SEARCH_RADIUS_SET': {
      return {
        ...state,
        value: action.radius,
        // userHasChanged if the user changed this value
        // in the past or in the current action
        userHasChanged: state.userHasChanged || action.didUserChange,
      };
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never;

      return state;
  }
}

// Actions

export const setSearchRadiusFunction = (
  radius: string,
  didUserChange: boolean
) => ({
  type: 'SEARCH_RADIUS_SET',
  radius,
  didUserChange,
});
export const setSearchRadius =
  (radius: string, didUserChange: boolean) => (dispatch: Dispatch) => {
    dispatch(setSearchRadiusFunction(radius, didUserChange));
  };
